import { cloneObject } from '../../../../utils';
import { getFields } from '../../../../utils/defaultFields';
import masks from '../../../../utils/masks.json';
import regexps from '../../../../utils/regexps';

const fields = [
    'cep',
    'address',
    'addressNumber',
    'complement',
    'hood',
    'uf',
    'city',
    'cellphone',
    'email',
    'comercialPhone',
    'ramal',
];

const defaultFields = cloneObject(getFields(fields));

defaultFields.email.required = false;
defaultFields.cellphone.required = false;

defaultFields.uf.required = false;
defaultFields.city.required = false;

const schema = {
    ...defaultFields,
    code: {
        id: 'code',
        label: 'Código',
        required: false,
        disabled: true,
    },
    name: {
        id: 'name',
        label: 'Nome da lotação',
        required: true,
        // regex: regexps.lettersNumbersAndSpaces,
        mask: '*'.repeat(15),
    },
    initials: {
        id: 'initials',
        label: 'Sigla da lotação',
        required: true,
        mask: '*'.repeat(15),
    },
    cnpj: {
        id: 'cnpj',
        label: 'CNPJ',
        mask: masks.cnpj,
        required: true,
        requiredMessage: 'Digite um CNPJ válido',
    },
    socialReason: {
        id: 'socialReason',
        label: 'Razão social',
        required: true,
        regex: regexps.lettersNumbersAndSpaces,
    },
    register: {
        id: 'register',
        label: 'Inscrição estadual',
        required: true,
        mask: '9'.repeat(20),
    },
    responsible: {
        id: 'responsible',
        label: 'Pessoa responsável',
        required: true,
        mask: 'b'.repeat(50),
    },
};

export default schema;
